import { Layout } from 'Components/Layout/Layout';
import { Chat } from 'Containers/Chat/Chat';

export const ChatPage = () => {
  return (
    <Layout>
      <Chat />
    </Layout>
  );
};
